import * as React from 'react';
import { useCallback, useState } from 'react';

import { Card, CardContent } from '@klareospace/pharos-lib-web-utils';
import type { CreateOrderType, UpdateOrderType } from '@klareospace/pharos-lib-types';

import { OrderTypeDrawer, OrderTypesActionBar, OrderTypesTable } from '../components';
import { useCreateOrderType, useOrderTypesPage } from '../hooks';
import { PageError } from '../components/order-types-status-views';

// ─── Page ─────────────────────────────────────────────────────────────────────

export default function OrderTypesPage(): React.JSX.Element {
  const pageState = useOrderTypesPage({ enabled: true });

  const createMutation = useCreateOrderType();
  const { mutateAsync: createOrderType } = createMutation;

  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleAdd = useCallback((): void => {
    setDrawerOpen(true);
  }, []);

  const handleDrawerClose = useCallback((): void => {
    setDrawerOpen(false);
  }, []);

  const handleDrawerSubmit = useCallback(
    async (data: CreateOrderType | UpdateOrderType): Promise<void> => {
      await createOrderType(data as CreateOrderType);
    },
    [createOrderType],
  );

  if (pageState.error) {
    return <PageError />;
  }

  const isLoading = pageState.isLoading;

  return (
    <div className="flex h-full flex-1 flex-col gap-4">
      <OrderTypesActionBar onAdd={handleAdd} />
      <Card className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl shadow-sm">
        <CardContent className="flex min-h-0 flex-1 flex-col p-0">
          <OrderTypesTable isLoading={isLoading} orderTypes={pageState.orderTypes} />
        </CardContent>
      </Card>
      <OrderTypeDrawer
        isPending={createMutation.isPending}
        onClose={handleDrawerClose}
        onSubmit={handleDrawerSubmit}
        open={drawerOpen}
        orderType={null}
      />
    </div>
  );
}
